// extracted by mini-css-extract-plugin
export default {"Constructor__scene":"TabletView_Constructor__scene__2zPSq","Constructor__steps":"TabletView_Constructor__steps__23hJi","Constructor__title":"TabletView_Constructor__title__15uTr"};